import { Spin } from "antd-v5";
import React from "react";
import { AssetEsDto } from "types/assetdetails";

import ACPageContainer from "ac-components/ACPageContainer/ACPageContainer";
import ACDrawer from "ac-components/ac-drawer/ACDrawer";

import AssetOverviewSection from "./AssetOverviewSection";
import AssetTagTableSection from "./AssetTagTableSection";

interface CorrelatedAssetDetailPanelProps {
  asset: AssetEsDto | null;
  open: boolean;
  onClose: () => void;
}

const CorrelatedAssetDetailPanel = ({
  asset,
  open,
  onClose,
}: CorrelatedAssetDetailPanelProps) => {
  const title = asset?.name || `Asset ${asset?.id}` || "Asset Details";

  return (
    <ACDrawer
      open={open}
      onClose={onClose}
      title={title}
      closable
      width={1020}
      destroyOnClose
      className="asset-modal"
    >
      {asset ? (
        <ACPageContainer className="m-0">
          <div className="asset-section-container">
            <AssetOverviewSection assetDetails={asset} isCorrelatedAsset />
            <AssetTagTableSection assetDetails={asset} readOnly />
          </div>
        </ACPageContainer>
      ) : (
        <div className="d-flex justify-content-center align-items-center h-100">
          <Spin />
        </div>
      )}
    </ACDrawer>
  );
};

export default CorrelatedAssetDetailPanel;
